<template>
  <AuthLayout>
    <TheLoader v-if="isEmailConfirmationProcessing" />
    <div v-else id="email-confirmation-page">
      <component
        :is="showComponent"
        v-bind="{
          ...(!isLinkExpired && { 'is-already-confirmed': isAlreadyConfirmed }),
          ...(isLinkExpired && { text: 'user-verify' }),
        }"
      />
    </div>
  </AuthLayout>
</template>

<script lang="ts" setup>
import AuthLayout from '@/layouts/auth.vue';
import AuthService from '@/services/AuthService';
import TheLoader from '@molecules/TheLoader/index.vue';
import TheEmailConfirmation from '@templates/TheEmailConfirmation/index.vue';
import TheLinkExpiredPage from '@templates/TheLinkExpiredPage/index.vue';
import { computed, ref } from 'vue';
import { useRoute } from 'vue-router';

const authService = new AuthService();
const route = useRoute();

const isEmailConfirmationProcessing = ref<boolean>(true);
const isAlreadyConfirmed = ref<boolean>(false);
const isLinkExpired = ref<boolean>(false);

const showComponent = computed(() => {
  if (isLinkExpired.value) {
    return TheLinkExpiredPage;
  }
  return TheEmailConfirmation;
});

async function confirmEmail() {
  try {
    await authService.emailReset({
      token: String(route.query?.token || ''),
    });
  } catch (e: any) {
    if (e.response.status === 409) {
      const message = e.response.data.message;

      isLinkExpired.value = message === 'Link is expired';
      isAlreadyConfirmed.value = message === 'User already confirmed';
    }
  } finally {
    isEmailConfirmationProcessing.value = false;
  }
}

confirmEmail();
</script>

<script lang="ts">
export default {
  name: 'TheEmailReset',
};
</script>

<style scoped lang="scss">
#email-confirmation-page {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}
</style>
